import { render, staticRenderFns } from "./CarouselTeamInfo.vue?vue&type=template&id=bb1b5b70&scoped=true&"
import script from "./CarouselTeamInfo.vue?vue&type=script&lang=js&"
export * from "./CarouselTeamInfo.vue?vue&type=script&lang=js&"
import style0 from "./CarouselTeamInfo.vue?vue&type=style&index=0&id=bb1b5b70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1b5b70",
  null
  
)

export default component.exports